import React, { useEffect, useState } from 'react';

const EPDeviceControl = (props) =>{

    return(
    <>
    </>
    )
}

export default EPDeviceControl